import { post } from './request';

export default function getDownLineSponsors(data) {
  return post('/api/downlineLookup', data).then(({ Result }) => Result);
}
